

/**
 * Import Dependency
 */

/**
 * Import API
 */

/**
 * Declare Variable
 */
const state = {
  isPanelVisible: false,
  isBusy: false,

  interval: 5 * 60 * 1000, // 15 minutes

  // Last `at` ts, which can be used as `fromTimeStamp` in next sync iteration
  fromTimestamp: null,

  // `at` ts for current sync process
  atTimestamp: null,

  // Results
  // syncedRecordsByTypeAndUuid: {
  //   requests: {},
  //   process: {},
  // },
  // syncedRecordsCountByType: {
  //   requests: 0,
  //   process: 0,
  // }
}

const getters = {
  // UI
  isBusy: state => !! state.isBusy,
  isPanelVisible: state => !! state.isPanelVisible,

  // TS
  getAtTimestamp: (state) => state.atTimestamp,
  hasAtTimestamp: (state) => state.atTimestamp !== null,
  getFromTimestamp: (state) => state.fromTimestamp,
  hasFromTimestamp: (state) => state.fromTimestamp !== null,

  getInterval: (state) => state.interval
}
const actions = {}

const mutations = {
  toggleBusy(state) {
    state.isBusy = ! state.isBusy
  },
  toggleVisibility(state) {
    state.isPanelVisible = ! state.isPanelVisible
  },
  setFirstSyncTimestamp(state) {
    state.atTimestamp = Math.floor(Date.now()) // - (1000 * 60 * 60 * 24 * 6)
  },
  setAtTimestamp(state, { ts }) {
    state.atTimestamp = ts
  },
  // TS should be the previously used atTimestamp
  setFromTimestamp(state, { ts }) {
    state.fromTimestamp = ts
  }
}

/**
 * Export
 */
export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
